document.addEventListener('on:variant:change', (event) => {
    // This logic assumes three option selectors (e.g. Farbe/Größe/Zustand) - skip for products with fewer options
    // Scope all lookups to the picker that fired the event, so other pickers on the page
    // (e.g. in a quick-add drawer) can't interfere
    const picker = event.target instanceof Element ? event.target.closest('variant-picker') : null;
    if (!picker || picker.querySelectorAll('.option-selector').length < 3) return;

    const allVariants = event.detail.product.variants

    // Check if variant exists and check for index page
    if (event.detail.variant === undefined && event.detail.optionIndex === 1 || event.detail.variant === undefined && event.detail.optionIndex === 2) {
        const selectByOption = event.detail.eventTarget;// blau
        const optionWithNumber = `option${event.detail.optionIndex}`
        const newVariant = allVariants.filter(variant => variant[optionWithNumber] === selectByOption)
        if (newVariant.length === 0) return;
        // Click the options of the new variant
        let inputOption1 = picker.querySelector(`input[value="${newVariant[0].option1}"]`);
        if (inputOption1 && !inputOption1.checked) inputOption1.click();
        let inputOption2 = picker.querySelector(`input[value="${newVariant[0].option2}"]`);
        if (inputOption2 && !inputOption2.checked) inputOption2.click();
        let inputOption3 = picker.querySelector(`input[value="${newVariant[0].option3}"]`);
        if (inputOption3 && !inputOption3.checked) inputOption3.click();

    } else {
        if (!event.detail.variant) return;
        const selectByOption = event.detail.eventTarget;
        const optionWithNumber = `option${event.detail.optionIndex}`
        const newVariant = allVariants.filter(variant => variant[optionWithNumber] === selectByOption)
        if (newVariant.length === 0) return;
        let inputOption2 = picker.querySelector(`input[value="${newVariant[0].option2}"]`);
        let inputOption3 = picker.querySelector(`input[value="${newVariant[0].option3}"]`);

        // Update the togglestate of all 'variant-size attributes'
        const availabilityList = allVariants.filter(variant => variant.option1 === event.detail.variant.option1);
        const availableObject = {}
        availabilityList.forEach(element => {
            if (!element.available) {
                availableObject[element.option2] = (availableObject[element.option2] + 1) || 1;
            }
        });
        const inputLength = picker.querySelectorAll('.option-selector')[2].querySelectorAll('input').length;
        for (const size in availableObject) {
            const sizeInput = picker.querySelector(`input[value="${size}"]`);
            if (!sizeInput) continue;
            sizeInput.setAttribute('variant-size', '');
            if (inputLength == availableObject[size]) {
                sizeInput.toggleAttribute('variant-size');

            }
        }
        // Click on events if they are available
        if (event.detail.variant.available === false) {
            if (inputOption2 && !inputOption2.checked && !inputOption2.classList.contains('is-unavailable')) {
                inputOption2.click();
            }
            if (inputOption3 && !inputOption3.checked && !inputOption3.classList.contains('is-unavailable')) {
                inputOption3.click();
            } else if (inputOption3) {
                const firstAvailable = inputOption3.parentElement.querySelector('input:not(.is-unavailable)')
                if (firstAvailable) firstAvailable.click();
            }
        }

    }
});
window.addEventListener("load", (event) => {
    // This logic assumes three option selectors - skip for products with fewer options
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker || variantPicker.querySelectorAll('.option-selector').length < 3) return;

    // Update initial state of the variant-picker
    // Get products / Variants
    const productData = variantPicker.getProductData();
    if (!productData || !productData.product || productData.product.variants.length === 0) return;
    const allVariants = productData.product.variants;
    // Find the first Variant
    const newVariant = allVariants.filter(variant => variant.option1 === allVariants[0].option1);
    const availabilityList = allVariants.filter(variant => variant.option1 === newVariant[0].option1);
    // Update the state /
    const availableObject = {}
    availabilityList.forEach(element => {
        if (!element.available) {
            availableObject[element.option2] = (availableObject[element.option2] + 1) || 1;
        }
    });
    // Check for availabe inputs and toggle data-attribute
    const inputLength = variantPicker.querySelectorAll('.option-selector')[2].querySelectorAll('input').length;
    for (const size in availableObject) {
        const sizeInput = variantPicker.querySelector(`input[value="${size}"]`);
        if (!sizeInput) continue;
        sizeInput.setAttribute('variant-size', '');
        if (inputLength == availableObject[size]) {
            sizeInput.toggleAttribute('variant-size');

        }
    }
});
